import { z } from 'zod';
import { SAME_DAY_TRAVEL_BUFFER_MINUTES } from './enrollments.js';

// --- Ogólne ustawienia wydarzenia w panelu admina (PRD §10 pkt 63) ---

/** Górna granica bufora na przejście między miejscami – 4 godziny. */
export const TRAVEL_BUFFER_MAX_MINUTES = 240;

/**
 * Reguły zapisu na kilka edycji jednego dnia. `blockOtherCitySameDay` – BR-17: osoba z zapisem (albo odprawą) w edycji w jednym
 * mieście nie zapisze się tego dnia w edycji w innym mieście; wyłączone – wszystkie edycje dnia można łączyć jak edycje jednego
 * miasta. `travelBufferMinutes` – najmniejsza przerwa między zajęciami osoby w dwóch edycjach tego dnia (0 = tylko bez nakładania).
 */
export const eventRulesSchema = z.object({
  blockOtherCitySameDay: z.boolean(),
  travelBufferMinutes: z.number().int().min(0).max(TRAVEL_BUFFER_MAX_MINUTES),
});
export type EventRules = z.infer<typeof eventRulesSchema>;

export const DEFAULT_EVENT_RULES: EventRules = {
  blockOtherCitySameDay: true,
  travelBufferMinutes: SAME_DAY_TRAVEL_BUFFER_MINUTES,
};

/** Panel admina: ustawienia z czasem ostatniej zmiany. */
export const adminEventRulesSchema = eventRulesSchema.extend({ updatedAt: z.string().nullable() });
export type AdminEventRules = z.infer<typeof adminEventRulesSchema>;
